<template>
	<div class="mdc-snackbar" aria-live="assertive" aria-atomic="true" aria-hidden="true">
		<div class="mdc-snackbar__text"></div>
		<div class="mdc-snackbar__action-wrapper">
			<button type="button" class="mdc-button mdc-snackbar__action-button"></button>
		</div>
	</div>
</template>

<script>
	// Dependencies
	import { MDCSnackbar } from '@material/snackbar'

	// Defaults
	const DEFAULTS = {
		message: '',
		timeout: 2750,
		multiline: false,
		actionOnBottom: false,
		actionText: 'close',
		actionHandler: () => {
			this.snackbar.hide()
		},
	}

	// Export
	export default {
		name: 'snackbar',
		data: () => ({
			queue: [],
			option: {},
			timer: null,
		}),
		mounted() {
			this.snackbar = new MDCSnackbar(this.$el)
			this.snackbar.dismissesOnAction = true
		},
		methods: {
			show(options) {
				const opts = Object.assign({}, DEFAULTS, options)
				this.snackbar.show(opts)
			},
		},
		computed: {
			merged() {
				return Object.assign({}, DEFAULTS, this.option)
			},
		},
		watch: {
			queue(to, from) {
				const pending = this.queue.length
				if (!pending) {
					return
				}

				this.option = this.queue[0]
				const merged = Object.assign({}, DEFAULTS, this.option)
				this.snackbar.show(merged)
				this.timer = setTimeout(() => {
					this.queue.shift()
					clearTimeout(this.timer)
				}, merged.timeout)

			},
		},
	}
</script>

<style scoped lang="scss">
	@import '@material/snackbar/mdc-snackbar';
	@import '@material/button/mdc-button';

	.mdc-snackbar { 
		transform: translateY(100%);
		z-index: 300;
	}

	.mdc-snackbar__action-button {
		color: #64dd17;
		color: var(--mdc-theme-accent, #64dd17);
	}
</style>


// WEBPACK FOOTER //
// src/lib/snackbar/Snackbar.vue